<script setup lang="ts">
import {useI18n} from "vue-i18n";
import {useRoute} from "vue-router";
import {computed} from "vue";
import type {UserInterface} from "@/stores/user.ts";

const { t } = useI18n();
defineProps<{ auth: UserInterface }>();
const route = useRoute();
const active = computed(() => route.path);
</script>
<template>
    <el-menu
            class="admin-menu w-100"
            mode="horizontal"
            router
            menu-trigger="click"
            ellipsis
            :default-active="active"
    >
        <el-menu-item index="/">
            <img src="/new-logo.png" alt="Donna Bella" style="width: 75px" />
        </el-menu-item>

        <el-menu-item index="/administration/reservations">
            {{ t('reservations') }}
        </el-menu-item>

        <el-menu-item v-if="auth.is_admin === 1" index="/administration/users">
            {{ t('users') }}
        </el-menu-item>

        <el-menu-item v-if="auth.is_admin === 1" index="/administration/services">
            {{ t('services') }}
        </el-menu-item>

        <el-menu-item v-if="auth.is_admin === 1" index="/administration/persons">
            {{ t('specialists') }}
        </el-menu-item>

        <el-menu-item v-if="auth.is_admin === 1" index="/administration/working-time">
            {{ t('working_time') }}
        </el-menu-item>

        <el-menu-item v-if="auth.is_admin === 1" index="/administration/infos">
            {{ t('pages') }}
        </el-menu-item>
    </el-menu>
</template>

<style scoped>
:root { scrollbar-gutter: stable; }
</style>
